import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useSettings } from "@/context/SettingsContext";
import api from "@/lib/api";

function getSessionId() {
  let sid = sessionStorage.getItem("visit_session_id");
  if (!sid) {
    sid = `vs_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("visit_session_id", sid);
  }
  return sid;
}

export default function Layout({ children }) {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  const tracked = useRef("");

  useEffect(() => {
    if (tracked.current === pathname) return;
    tracked.current = pathname;
    api.post("/track/visit", { path: pathname, session_id: getSessionId() }).catch(() => {});
  }, [pathname]);

  // Heartbeat so we can measure time spent on the site
  useEffect(() => {
    const sid = getSessionId();
    const beat = () => {
      if (document.visibilityState === "visible") {
        api.post("/track/heartbeat", { session_id: sid }).catch(() => {});
      }
    };
    const interval = setInterval(beat, 15000);
    document.addEventListener("visibilitychange", beat);
    window.addEventListener("beforeunload", beat);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", beat);
      window.removeEventListener("beforeunload", beat);
    };
  }, []);

  useEffect(() => {
    if (settings?.shop_name) document.title = settings.shop_name;
  }, [settings?.shop_name]);

  const bg = settings?.background || "confetti";

  return (
    <div className={`min-h-screen flex flex-col bg-${bg}`} data-testid="public-layout">
      <div className="paper-noise fixed inset-0 pointer-events-none z-0" />
      <div className="relative z-10 flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </div>
  );
}
